export default {
    booking: {
        exhaustedQuarter: 'No included onsite allowance is available for Q{quarter} {year}. You can choose a future quarter with available allowance under your contract, or contact your MarketScale representative to arrange a paid additional onsite.',
    },
    design: {
        savedScaleUp: 'Scale-Up saved for later', unsavedScaleUp: 'Scale-Up not saved', noAllotmentChange: 'No allotments added or deducted',
        reviewContractTotal: 'Review contract total',
        productionReference: 'On-site production #{id}', oneAllotment: '{count} allotment', manyAllotments: '{count} allotments',
        addedEffect: 'added', deductedEffect: 'deducted', reservedEffect: 'reserved', usedEffect: 'used',
        sortAscending: 'ascending', sortDescending: 'descending', sortColumn: 'sort',
        date: 'Date', description: 'Description', starts: 'Start date', ends: 'End date', status: 'Status', included: 'Included allotments', issued: 'Invoice date',
        currentContract: 'Current contract', allotmentOverview: 'Allotment overview', includedQuarter: '{count} scheduled per quarter from Studio tier',
        reviewBookingsWarning: 'Totals include Studio productions using recorded coverage or a default of one allotment per day. {count} historical bookings still need review and may change usage and remaining.',
        recordedTotalsHelp: 'Includes Studio productions using recorded coverage or one allotment per day where coverage is missing. Review may change these totals.',
        reviewBookingLink: 'Review production #{id}', reviewBookingsMore: 'Open the production queue to review the remaining bookings.',
        contractTotalMetric: 'Contract total', remaining: 'Remaining', contractScope: 'Full contract · includes future quarters', contractAdditions: 'Added allotments: {count}',
        periodTotal: 'Total this quarter', addedThisQuarter: '{count} added this quarter', carryover: 'Includes {count} carried forward',
        viewDetails: 'Activity', adjust: 'Record Other Use', synced: 'Contract synced', syncAttention: 'Sync needs attention',
        contractsBilling: 'Contracts & Billing', serviceSubscription: 'Service subscription', studioTier: 'Studio tier',
        contractsBillingDescription: 'Service contracts, customer invoices, and sync details. Hidden from customers.',
        studioTierSource: 'Studio tier: {tier}', subscriptionQuarters: '{count} quarters', brandedChannels: 'Branded channels: {count}', hostedPodcast: 'Hosted podcast: {value}',
        contracts: 'Contracts', billing: 'Billing', entryDetails: 'Details', recordedBy: 'User #{actor}',
        contractTotal: '{count} included allotments', billingSource: 'Customer invoices from Salesforce',
        refresh: 'Refresh', invoice: 'Invoice', due: 'Due date', balance: 'Balance', noInvoices: 'No invoice records available yet.',
        noMatchingInvoices: 'No invoices match this search or status.', searchInvoices: 'Search invoice number', searchInvoicePlaceholder: 'Invoice number', filterInvoices: 'Status',
        filterBy: 'Filter by', clearSearch: 'Clear search',
        searchActivity: 'Search activity', searchActivityPlaceholder: 'Description, type, reference, or user', activityType: 'Type', noMatchingActivity: 'No activity matches this search or type.',
        searchContracts: 'Search contracts', searchContractPlaceholder: 'Contract ID', filterContracts: 'Status', noMatchingContracts: 'No contracts match this search or status.',
        showingRows: 'Showing {start}–{end} of {total}', previousPage: 'Previous', nextPage: 'Next', pageOf: 'Page {page} of {total}',
        syncTitle: 'Data & sync', syncDescription: 'Connection status and contract controls.',
        contractData: 'Service contracts', lastSync: 'Last successful sync', notSynced: 'Not synced yet',
        technicalDetails: 'Technical details & contract corrections',
        billingOff: 'Payment checks off', billingUnverified: 'Salesforce check incomplete', billingHold: 'Salesforce past-due balance', billingClear: 'No Salesforce past-due hold',
        billingNotLinked: 'Salesforce account not linked', billingMappingConflict: 'Salesforce account mapping conflict',
        adjustTitle: 'Record Other Use', adjustDescription: 'Use allotments for work outside an on-site production.',
        saveAdjustment: 'Save adjustment', saveUse: 'Record Usage', otherActions: 'Other actions: transfer or reverse',
        usagePreviewHelp: 'Contract total stays the same. Remaining allotments decrease.',
        previewUnavailable: 'A balance preview is unavailable until the contract total is confirmed.',
        amountHelp: 'Amount charged; payment is tracked separately.',
        addReasonPlaceholder: 'Why are these allotments being added?',
        useReasonPlaceholder: 'For example, two allotments used for a video re-edit.',
    },
    refreshPayment: 'Refresh payment status',
    refreshQueued: 'Payment refresh queued. Status remains unverified until the provider check completes.',
    refreshFailed: 'Could not queue a payment refresh. Please wait a moment and try again.',
    paymentNotLinked: 'No linked billing customer; no payment hold is applied.',

    heading: 'On-Site Allotments',
    summaryDescription: 'Current period, reservations, and available productions.',
    quarterly: 'Quarterly',
    booked: 'Booked',
    studioTier: 'Studio tier: {tier}',
    serviceTotal: 'Service total: {count}',
    periodInferred: 'Allotments release by calendar quarter within the Service contract dates; the tier schedule is configured in Studio',
    servicePeriodInferred: 'Allotments release by calendar quarter within the Service contract dates; subscription details come from Service.',
    scheduledThisPeriod: 'Studio: {count} per quarter',
    totalReviewPending: 'Service total amendment awaiting staff review',
    inferredFallback: 'Inferred {tier} tier estimate while Service data is unavailable: limit {limit}, combined commitments {used}, remaining {remaining}.',
    carried: 'Includes {count} carried from earlier periods in this contract',
    bookedFromThisPeriod: '{count} future reservations draw on capacity available in this period',
    contractsHistory: 'Contracts & History',
    activity: 'Activity',
    productionPlanChanged: 'Production coverage changed',
    advancedChanges: 'Advanced changes',
    syncBillingDetails: 'Sync & billing details',
    syncVerified: 'Service synced',
    syncAttention: 'Service sync needs attention',
    syncStatus: 'Service sync: {status}',
    lastVerified: 'Last successful Service sync: {date}',
    syncError: 'Sync issue: {category}',
    active: 'Active',
    upcoming: 'Upcoming',
    expired: 'Expired',
    invoiceHistory: 'Observed invoices',
    invoiceUnverified: 'Studio has not completed a current Salesforce invoice check. Rows show the last known Salesforce data. Refresh Billing to check again.',
    salesforceChecked: 'Salesforce invoices checked {date}. Payment updates take effect in Studio after they appear in Salesforce and the next check completes.',
    pastDue: 'Past due',
    invoiceStates: { all: 'All', outstanding: 'Outstanding', pastDue: 'Past due', upcoming: 'Upcoming', paid: 'Paid', cancelled: 'Cancelled', draft: 'Draft', unknown: 'Unknown' },
    contractStates: { active: 'Active', upcoming: 'Upcoming', pending: 'Pending', paused: 'Paused', expired: 'Expired', inactive: 'Inactive', cancelled: 'Cancelled' },
    paid: 'Paid',
    audit: 'Recorded by user #{actor} at {time}',
    addTitle: 'Add On-Site Allotments',
    addDescription: 'Add a Scale-Up or complimentary Client Win.',
    addSubmit: 'Add Allotments',
    additionType: 'Addition Type',
    reasonForAddition: 'Reason for Addition',
    period: 'Contract period',
    choosePeriod: 'Choose a period',
    decrease: 'Decrease allotments',
    increase: 'Increase allotments',
    paidAddition: 'Scale-Up',
    clientWin: 'Client Win',
    usdAmount: 'Amount (USD)',
    added: 'Allotment added',
    changed: 'Allotment change recorded',
    used: 'Used',
    contractTotal: 'Contract total',
    quarterlyTotal: 'Quarterly allowance',
    unlimitedAvailable: 'Available',
    unlimitedTotal: 'Unlimited',
    tierFallback: '{tier} tier allowance is shown while the Service contract total is unavailable.',
    tierContractFallback: '{tier} allowance follows this Service contract while no quarterly limit is set.',
    periodDates: '{start} to {end}',
    syncForAdjustments: 'A current or upcoming verified Service contract and period are required to add allotments.',
    recordUse: 'Record usage',
    close: 'Close',
    contractDetails: 'Contract and sync details',
    refreshContract: 'Refresh contract',
    contractRefreshQueued: 'Contract refresh queued. This panel will check for updates for the next minute.',
    contractRefreshPending: 'Contract refresh is already in progress. This panel will check for updates for the next minute.',
    contractRefreshFailed: 'Could not queue a contract refresh. Please try again.',
    description: 'Contract allowances, staff adjustments and usage. Payment references remain pending until verified by the provider.',
    availabilityDate: 'Availability for production date',
    loading: 'Loading on-site allotments…',
    unavailable: 'On-site allotments are unavailable. Try again.',
    noContracts: 'No Service contract is available for this channel yet.',
    contract: 'Contract',
    serviceBase: 'Service contract total',
    effectiveBase: 'Base after approved correction',
    adjustments: 'Staff additions, transfers and other usage (net)',
    additions: 'Staff additions',
    transfers: 'Transfers in / out',
    productionUse: 'Production usage',
    otherUseTotal: 'Other usage',
    retainedUse: 'Retained cancellation usage',
    remaining: 'Full-term remaining',
    available: 'Available',
    shortfall: 'Allotment shortfall: {count}',
    pendingCount: '{count} funding items await verification or review',
    paymentModes: {
        enforce: 'Salesforce past-due checks enabled',
        observe: 'Salesforce past-due checks: observation only',
        off: 'Salesforce past-due checks disabled',
        invalid: 'Salesforce past-due check configuration needs attention',
    },
    paymentUnavailable: 'payment status unavailable or stale',
    paymentSyncing: 'payment status syncing',
    paymentFreshnessUnknown: 'The Salesforce invoice check is incomplete. Refresh Billing to check again.',
    paymentOverdue: 'Salesforce shows a qualifying past-due account balance. Ordinary customer bookings are restricted.',
    fundingPending: 'Automatic Salesforce funding is pending. A clear account check does not verify annual, future, or scale-up payment.',
    actionHeading: 'Adjust onsite allowance',
    action: 'Action',
    add: '+ Add Allotment',
    otherUse: 'Record other use',
    transfer: 'Transfer to renewal',
    reverse: 'Reverse or correct an entry',
    entryToReverse: 'Entry to reverse',
    chooseEntry: 'Choose an entry',
    chooseContract: 'Choose a contract',
    quantity: 'Allotments',
    targetContract: 'Renewal contract',
    sourceContract: 'Source contract',
    selectedSource: 'Updating contract',
    classification: 'Reason category',
    scaleUp: 'Scale-up',
    goodwill: 'Goodwill',
    correction: 'Correction',
    effectiveDate: 'Usage date',
    reason: 'Explanation (required)',
    amount: 'Reported amount (optional)',
    currency: 'Currency when amount is supplied',
    unverified: 'A reported amount or reference does not verify payment.',
    reference: 'Order or invoice reference (optional)',
    link: 'Supporting link (optional)',
    estimatedRemaining: 'Estimated full-term remaining: {count}',
    estimatedShortfall: 'Estimated allowance shortfall: {count}',
    expires: 'Unused additions carry forward within this contract and expire on {date}.',
    viewLink: 'Supporting link',
    save: 'Record change',
    saveError: 'The change could not be saved. Refresh the balance and try again.',
    invalidEntry: 'Choose a valid whole-number quantity, period, and target.',
    invalidAmount: 'Enter a valid amount and three-letter currency.',
    history: 'Allowance history',
    noHistory: 'No activity recorded.',
    ambiguousContracts: 'Overlapping active Service contracts need review before allotments can be shown or added.',
    cancelled: 'Cancelled',
    draft: 'Draft',
    coverageLabels: { credit: 'Included', scaleUp: 'Scale-up', mixed: 'Mixed' },
    unknown: 'Unknown',
    types: { add: 'Added', use: 'Other use', transfer: 'Transfer', transfer_in: 'Transfer in', transfer_out: 'Transfer out', reverse: 'Reversal', retention: 'Retained on cancellation', booked: 'Booked', completed: 'Completed', production_charge: 'Production booked', production_adjustment: 'Production changed', production_release: 'Cancellation released', production_reallocation: 'Production reallocated', override: 'Admin override' },
    coverage: {
        title: 'Manage On-Site Production Coverage',
        subtitle: 'Choose how each production day is covered.',
        dayHeading: 'Day {day} — {date}',
        options: {
            credit: { title: 'On-Site Allotment', description: "Uses the customer's included on-site allotments." },
            scale_up: { title: 'Paid Scale-Up', description: 'Customer pays for this production.' },
            mixed: { title: 'Mixed Coverage', description: 'Uses allotments plus an additional payment.' },
        },
        allotments: 'On-Site Allotments Used',
        payment: 'Additional Payment',
        invalidQuantity: 'Enter a whole number from 1 to 100,000.',
        invalidPayment: 'Enter an amount greater than $0, with up to two decimal places.',
        paymentCurrency: 'Additional Payment ({currency})',
        decrease: 'Use one fewer allotment for day {day}',
        increase: 'Use one more allotment for day {day}',
        summary: 'Production Coverage Summary',
        days: 'Production Days',
        remaining: 'Remaining on production date',
        unknownBalance: 'Unavailable',
        updating: 'Updating remaining allotments…',
        balanceUnavailable: 'Remaining allotments could not be refreshed. Saving will check the balance again.',
        reason: 'Reason for Change',
        reviewPrompt: 'This historical booking has unverified coverage. Check each day, then save with a reason to confirm its allotment use. Opening this editor makes no changes.',
        confirmReview: 'Confirm Coverage',
        required: '(at least 10 characters)',
        reasonPlaceholder: 'Briefly explain why the production coverage is being updated...',
        cancel: 'Cancel',
        save: 'Save Coverage',
        saving: 'Saving…',
        saved: 'Production coverage updated',
        saveError: 'Coverage could not be saved. Your changes are still here; please try again.',
        reload: 'Reload coverage',
        discardTitle: 'Discard coverage changes?',
        discardDescription: 'Your unsaved production coverage changes will be lost.',
        keepEditing: 'Keep editing',
        discard: 'Discard changes',
        legacyCurrency: 'Existing payment kept in its original currency. New payments use USD.',
    },
    usage: {
        manage: 'Production coverage',
        title: 'Manage allowance usage',
        description: 'Set contract allowance usage and scale-up coverage for each production day.',
        loading: 'Loading allowance usage…',
        unavailable: 'Production coverage is unavailable.',
        day: 'Production day',
        coverage: 'Coverage',
        credit: 'Contract allowance',
        scaleUp: 'Scale-up',
        mixed: 'Mixed',
        credits: 'Allowance units for this day',
        extra: 'Additional allowance used for nonstandard scope',
        amount: 'Reported package amount (optional)',
        currency: 'Currency',
        reference: 'Order or invoice reference (optional)',
        link: 'Supporting link (optional)',
        reason: 'Reason for change',
        default: 'Default: one allowance unit per production day.',
        charge: 'Allowance used: {count}',
        released: 'Allowance returned: {count}',
        balance: 'Available after change: {count}',
        shortfall: 'Allotment shortfall: {count}',
        pending: 'Awaiting payment verification',
        fundingFilter: 'Funding status',
        allFunding: 'All funding',
        needsAttention: 'Needs attention',
        needsReview: 'Needs funding review',
        allocated: 'Contract allowance allocated',
        verified: 'Verified paid',
        preview: 'Preview change',
        save: 'Save allowance usage',
        close: 'Close',
        stale: 'This production changed while you were editing. Reload and review its allowance usage.',
        error: 'Production coverage could not be saved. Please try again.',
        invalid: 'Enter valid whole-number allowance quantities, a reason, and currency with any amount.',
        saved: 'Production coverage updated',
        retain: 'Keep allotments charged after cancellation',
        retainQuantity: 'Allowance units to retain',
        retainReason: 'Reason for retention',
        releaseDefault: 'Cancellation releases reserved allotments by default.',
        overrideReason: 'Reason for staff booking override',
        overrideHelp: 'A reason is required to proceed. The booking restriction and reason will be audited.',
    },
}
